import Slot from './Slot'
import './slots.css'

export default Slot
